import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { createSlug } from '../../util/urlHelpers';
import { NamedLink } from '../../components';

import css from './MakeOfferButton.module.css';

/**
 * CL-NEG-01 Task 10 — "Make an Offer" on the listing page (requirement 1, AC1).
 *
 * A seller cannot make an offer on their own listing, so there it renders as an inert preview
 * (same as AddToCartButton). An offer on a sold-out listing could never be paid — the payment
 * join's `create-pending-stock-reservation` (process.edn:292) would have nothing to reserve, so
 * the buyer would spend 48 hours on a dead end. D12: an offer itself reserves NOTHING; this guard
 * is about whether the offer could ever complete, not about holding anything.
 */
const MakeOfferButton = props => {
  const { listing, isOwnListing, currentStock, className, rootClassName } = props;
  const offersEnabled = listing?.attributes?.publicData?.offersEnabled === true;

  // AC1: on a Buy It Now only listing the button simply is not there. The route refuses a
  // directly-typed URL on its own (offer-initiate answers `offers-not-enabled`), so this is the
  // presentational half of the same rule.
  if (!offersEnabled) return null;
  // An offer that could never be paid: there is no stock to reserve at checkout.
  if (currentStock === 0) return null;

  // The seller sees the button exactly as a buyer would, so the listing page previews
  // truthfully, but it goes nowhere: like the template's Buy now on an own listing, a click
  // only scrolls up to the "This is your own listing" bar. A <button>, because NamedLink
  // drops onClick.
  if (isOwnListing) {
    return (
      <button
        type="button"
        className={classNames(rootClassName || css.root, className)}
        onClick={() => window.scrollTo(0, 0)}
      >
        <FormattedMessage id="MakeOfferButton.label" />
      </button>
    );
  }

  return (
    <NamedLink
      className={classNames(rootClassName || css.root, className)}
      name="BuyerOfferPage"
      params={{ id: listing.id.uuid, slug: createSlug(listing.attributes.title) }}
    >
      <FormattedMessage id="MakeOfferButton.label" />
    </NamedLink>
  );
};

export default MakeOfferButton;
